export const SUPPORTED_LANGUAGES = ['en', 'nl'] as const;
export const PREFERRED_LANGUAGE_STORAGE_KEY = 'preferred-language';

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'nl';
export const DEFAULT_INTL_LOCALE = 'en-NL';

const INTL_LOCALE_BY_LANGUAGE: Record<SupportedLanguage, string> = {
  en: DEFAULT_INTL_LOCALE,
  nl: 'nl-NL',
};

export function isSupportedLanguage(value: unknown): value is SupportedLanguage {
  return typeof value === 'string' && (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
}

export function normalizeLanguage(value: string | null | undefined): SupportedLanguage {
  const language = value?.trim().split(/[-_]/)[0]?.toLowerCase();
  return isSupportedLanguage(language) ? language : DEFAULT_LANGUAGE;
}

export function resolveIntlLocale(language: string | null | undefined): string {
  return INTL_LOCALE_BY_LANGUAGE[normalizeLanguage(language)];
}
